import { render, staticRenderFns } from "./lookCommodity.vue?vue&type=template&id=18ab9946&scoped=true&"
import script from "./lookCommodity.vue?vue&type=script&lang=js&"
export * from "./lookCommodity.vue?vue&type=script&lang=js&"
import style0 from "./lookCommodity.vue?vue&type=style&index=0&id=18ab9946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab9946",
  null
  
)

export default component.exports